import { createAction, props } from '@ngrx/store';
import { EmployabilityModel } from '@reducers/orm/employability/employability.model';

export const employabilityLoad = createAction('[Employability] Load', props<{ employability: EmployabilityModel[] }>());
